import { useEffect, useRef } from "react";

// Physical (desktop) keyboard handling for the crossword workspace.
export function useCrosswordKeys(active, handlers) {
  const ref = useRef(handlers);
  ref.current = handlers;
  useEffect(() => {
    if (!active) return;
    const onKey = (e) => {
      const h = ref.current;
      if (h.drawerOpen && e.key === "Escape") { e.preventDefault(); h.closeDrawer(); return; }
      if (/^[a-zA-Z]$/.test(e.key)) { e.preventDefault(); h.typeLetter(e.key.toUpperCase()); }
      else if (e.key === "Backspace") { e.preventDefault(); h.backspace(); }
      else if (e.key === "Enter") { e.preventDefault(); h.nextEntry(); }
      else if (e.key === "ArrowRight" || e.key === "ArrowLeft") { e.preventDefault(); h.setDirection("across"); }
      else if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); h.setDirection("down"); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);
}
